module.exports = __webpack_public_path__ + "img/whtop_bg.09a6385c.jpg";